import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import moment from "moment";
import {
  Button,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody
} from "reactstrap";
import ExpandedRule from "./ExpandedRule";
import VitalsIcon from "../../../../files/vitals.jpg";
import TimeIcon from "../../../../files/timeadherence.jpg";
import AdherenceIcon from "../../../../files/adherence.svg";
import ReminderIcon from "../../../../files/reminder.jpg";
import TrendingIcon from "../../../../files/trending.svg";
import _ from "lodash";

const CommonSearch = ({ onSearch }) => (
  <div className="admin-search-wrapper">
    <i className="mdi mdi-magnify admin-search-icon" />
    <input
      type="text"
      className="form-control input-date-filter remove-bottom-margin admin-search-input"
      placeholder="Search expectation name, type, reading..."
      onChange={(event) => onSearch(event.target.value)}
    />
  </div>
);

function withIcon(cell) {
  let icon;
  switch (cell) {
    case "Vitals":
      icon = VitalsIcon;
      break;
    case "Time Adherence":
      icon = TimeIcon;
      break;
    case "Adherence":
      icon = AdherenceIcon;
      break;
    case "Reminder":
      icon = ReminderIcon;
      break;
    case "Trending Violation":
      icon = TrendingIcon;
      break;
    case "Weight":
      icon = "https://cdn-icons-png.flaticon.com/512/249/249236.png";
      break;

    default:
      break;
  }
  return (
    <span>
      <img src={icon} className="mr-2" alt="image" />
      {cell == "Weight" ? "Weight Difference" : cell}
    </span>
  );
}

function formatDate(cell) {
  return moment(cell).format("MMMM DD, YYYY hh:mm A");
}
function priceFormatter(column, colIndex, { sortElement, filterElement }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span className="mb-2">{filterElement}</span>

      {column.text}
      {sortElement}
    </div>
  );
}
function showButtons(cell, row, rowIndex, formatExtraData) {
  const authenticatedUser = formatExtraData.userId;
  if (row) {
    const isSameUser = authenticatedUser !== row.receivedBy._id;
    const approvedButton =
      isSameUser && !row.isApproved ? (
        <button
          type="button"
          onClick={() => formatExtraData.approve(row._id)}
          className="btn btn-success btn-fw"
        >
          Accept Request
        </button>
      ) : (
        ""
      );
    return (
      <span>
        {row.isApproved ? (
          <button
            type="button"
            onClick={() => formatExtraData.delete(row._id)}
            className="btn btn-danger btn-fw"
          >
            Delete
          </button>
        ) : (
          approvedButton
        )}
      </span>
    );
  }
}
function checkSubType(cell, row, index, myRules) {
  if (row.ruleType === "Trending Violation") {
    const rule = _.find(myRules, { _id: row.rule[0].ruleId });
    if (rule) {
      return <div>Expectation Name: {rule.name}</div>;
    }
    return "";
  }

  return row.ruleType == "Weight" ? "Weight" : cell;
}
function ruleCheck(cell, row, index) {
  const { sharedUsers = [], conditionGroup = [] } = row;
  if (_.size(sharedUsers) === 0 && _.size(conditionGroup) === 0) {
    return (
      <div>
        <UncontrolledPopover
          trigger="legacy"
          placement="bottom"
          target={"test" + row._id}
        >
          <PopoverHeader>Need Setup</PopoverHeader>
          <PopoverBody>
            This expectation is a default one that needs to add a patient to
            monitor or a condition group which has multiple patients, you can
            modify it and delete if you want.
          </PopoverBody>
        </UncontrolledPopover>
        {cell} {"  "}
        <Button
          id={"test" + row._id}
          type="button"
          className="text-danger btn btn-dark btn-rounded float-right"
        >
          <i class="mdi mdi-alert-decagram btn-icon-prepend text-danger"></i>
        </Button>
      </div>
    );
  }
  return cell;
}
const expandRow = {
  renderer: row => (
    <div>
      <ExpandedRule ruleDetails={row} key={row._id + "water"} />
    </div>
  ),
  showExpandColumn: true
};
const RuleList = (props, context) => {
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [
      {
        text: "10",
        value: 10
      },
      {
        text: "20",
        value: 20
      },
      {
        text: "All",
        value: props.myRules.length
      }
    ] // A numeric array is also available. the purpose of above example is custom the text
  };
  return (
    <>
      <ToolkitProvider
        keyField="_id"
        data={props.myRules}
        search
        columns={[
          {
            dataField: "name",
            text: "Expectation Name",
            sort: true,
            formatter: ruleCheck,
            headerFormatter: priceFormatter
          },
          {
            dataField: "ruleType",
            text: "Expectation Type",
            sort: true,
            formatter: withIcon,
            headerFormatter: priceFormatter
          },
          {
            dataField: "readingSubType",
            text: "Reading Type",
            sort: true,
            formatter: checkSubType,
            headerFormatter: priceFormatter,
            formatExtraData: props.myRules
          }
        ]}
      >
        {(toolkitProps) => (
          <>
            <div className="admin-table-toolbar mb-2">
              <div className="admin-table-toolbar-search">
                <CommonSearch {...toolkitProps.searchProps} />
              </div>
            </div>
            <div className="scrollbar-table-cls">
              <BootstrapTable
                wrapperClasses="table-responsive"
                keyField="_id"
                noDataIndication="No Data Found"
                expandRow={expandRow}
                pagination={paginationFactory(options)}
                {...toolkitProps.baseProps}
              />
            </div>
          </>
        )}
      </ToolkitProvider>
    </>
  );
};

export default RuleList;
